import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {ConversationInquirySummarySentenceModel} from '../../../../../../libs/shared/core/src/models/api/conversationInquiriesModel';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {SynopsisQuickActions} from './synopsisQuickAction';
import {SynopsisTimestamp} from './synopsisTimestamp';

interface SynopsisCellDetailProps {
  className?: string;
  statusIcon?: ReactNode;
  timestamp: number;
  actions?: ReactNode;
  isFollowUp?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: ReactNode;
}

const StyledCellDetailButton = styled(ChromelessButton)`
  position: relative;
  padding: 4px 8px;
  border-radius: 8px;
  margin: 0 4px;

  &:hover {
    background-color: ${(p) => p.theme.alphas.black20};
  }
`;

const StyledInnerDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

const StyledStatusDiv = styled.div`
  margin: 2px 3px 0 0;
  flex: 0 0 16px;
`;

const StyledContentDiv = styled.div`
  flex: 1;
  line-height: 1.5;
  position: relative;
  overflow: hidden;
`;

const StyledTimestampDiv = styled.div`
  margin-top: 4px;
`;

export const SynopsisCellDetail: FC<SynopsisCellDetailProps> = ({
  className,
  statusIcon,
  timestamp,
  actions,
  isFollowUp,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
}) => (
  <SynopsisQuickActions actions={actions} right={5.5} bottom={1.5}>
    <StyledCellDetailButton
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
    >
      <StyledInnerDiv>
        <StyledStatusDiv>{statusIcon}</StyledStatusDiv>
        <StyledContentDiv>{children}</StyledContentDiv>
        {isFollowUp && (
          <StyledTimestampDiv>
            <SynopsisTimestamp timestamp={timestamp} />
          </StyledTimestampDiv>
        )}
      </StyledInnerDiv>
    </StyledCellDetailButton>
  </SynopsisQuickActions>
);

const StyledStrong = styled.strong`
  text-transform: capitalize;
`;

export const SynopsisSummary: FC<{summary: ConversationInquirySummarySentenceModel}> = ({summary}) => (
  <>
    <StyledStrong>{summary.verb}</StyledStrong> {summary.remainder}
  </>
);
